// removed by extract-text-webpack-plugin
module.exports = {"anchor":"anchor___262Oe","section-slidedown-button":"section-slidedown-button___1u_kQ center___2iqBf","section-slidedown-label":"section-slidedown-label___3spE4 h1___3_4RF","section-slidedown-icon":"section-slidedown-icon___BLjUd h1___3_4RF","plan-scorecard-company-letter":"plan-scorecard-company-letter___2LcC- h3___5u0xZ","company-letter-blockquote":"company-letter-blockquote___3oNU1 h4___kHWTn","signature-image":"signature-image___SLw0p","scroll-link":"scroll-link___2UID7","sample-ad-img":"sample-ad-img___13VJF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanScorecardCompanyLetter/PlanScorecardCompanyLetter.css
// module id = 32
// module chunks = 0